export const isUSRegion = (region: any): region is 'USA' | 'UNITED STATES' => {
  return (
    typeof region === 'string' &&
    (region.toUpperCase() === 'USA' || region.toUpperCase() === 'UNITED STATES')
  )
}
